import { combineReducers } from 'redux';

import {
  LIBRARY_PROMO_CLOSE_RIGHT_COLUMN,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_OPEN_RIGHT_COLUMN,
  LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY,
  LIBRARY_PROMO_SET_CURRENT_PAGE,
  LIBRARY_PROMO_SET_DETAIL_PROMO,
  LIBRARY_PROMO_SET_INTERSECT_CATEGORIES,
  LIBRARY_PROMO_SET_INTERSECT_ITEMS,
  LIBRARY_PROMO_SET_INTERSECT_VARIANTS,
  LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM,
  LIBRARY_PROMO_SET_IS_SUBMITTING_FORM,
  LIBRARY_PROMO_SET_LIST_PROMO,
  LIBRARY_PROMO_SET_OUTLETS,
  LIBRARY_PROMO_SET_PROMO_TYPES,
  LIBRARY_PROMO_SET_SELECTED_OUTLETS,
  LIBRARY_PROMO_SET_TOTAL_PAGE,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_SET_DELETED_PROMO,
  LIBRARY_PROMO_SHOW_DELETE_MODAL,
  LIBRARY_PROMO_HIDE_DELETE_MODAL,
  LIBRARY_PROMO_SET_DEACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL,
  LIBRARY_PROMO_SET_REACTIVATED_PROMO,
  LIBRARY_PROMO_SHOW_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_REACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS,
  LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION,
  LIBRARY_PROMO_SET_ACTION_UPDATE_NAME,
  LIBRARY_PROMO_HIDE_ASSIGN_ITEMS_MODAL,
  LIBRARY_PROMO_SHOW_ASSIGN_ITEMS_MODAL,
  LIBRARY_PROMO_SET_CATEGORIES,
  LIBRARY_PROMO_SET_ITEM_DETAILS,
  LIBRARY_PROMO_SET_NON_DELETED_PROMOS,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS,
  LIBRARY_PROMO_SET_ERRORS_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_CURRENT_PAGE,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_TOTAL_PAGE,
  LIBRARY_PROMO_SET_SELECTED_GOSTORE_ITEMS,
  LIBRARY_PROMO_SET_SELECTED_SALES_TYPES,
  LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_SET_SALES_TYPES,
  LIBRARY_PROMO_SET_SALES_TYPE_NAMESPACE,
  LIBRARY_PROMO_SET_ALREADY_ASSIGNED_OUTLET,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN_MODAL,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN_MODAL,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN,
  LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_WARN,
  LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_WARN,
  LIBRARY_PROMO_SET_PREVIOUS_SALES_TYPE,
} from '../../actions/businessLibrary/promo/constants';
import createReducer from '../../utils/createReducer';

const actionUpdateName = createReducer('', {
  [LIBRARY_PROMO_SET_ACTION_UPDATE_NAME]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.actionUpdateName,
});

const activeAccordion = createReducer('1', {
  [LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    String(payload.activeKey),
});

const categories = createReducer([], {
  [LIBRARY_PROMO_SET_INTERSECT_CATEGORIES]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.categories,
});

const currentPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_CURRENT_PAGE]: (draft, { payload }) => payload.currentPage,
});

const deactivatedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_DEACTIVATED_PROMO]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deactivatedPromo,
});

const deletedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_DELETED_PROMO]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deletedPromo,
});

const detailPromo = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_DETAIL_PROMO]: (draft, { payload }) => payload.detailPromo,
});

const isSubmitPromoForm = createReducer(
  {},
  {
    [LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.newPromoForm,
  }
);

const isSubmittingForm = createReducer(false, {
  [LIBRARY_PROMO_SET_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isSubmit,
});

const items = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_INTERSECT_ITEMS]: (draft, { payload }) => payload.items,
});

const nextUpdateAction = createReducer(null, {
  [LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.nextUpdateAction,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_PROMO_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_PROMO_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const previousAssignedOutlets = createReducer(null, {
  [LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.prevAssignedOutlet,
});

const promos = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_LIST_PROMO]: (draft, { payload }) => payload.promos,
});

const promoTypes = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_PROMO_TYPES]: (draft, { payload }) => payload.promoTypes,
});

const reactivatedPromo = createReducer(null, {
  [LIBRARY_PROMO_SET_REACTIVATED_PROMO]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.reactivatedPromo,
});

const selectedOutlets = createReducer([], {
  [LIBRARY_PROMO_SET_SELECTED_OUTLETS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.selectedOutlets,
});

const showAssignOutletModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL]: () => false,
});

const showConfirmReactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL]: () => false,
});

const showDeactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL]: () => false,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_DELETE_MODAL]: () => false,
});

const showReactivateModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_REACTIVATE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_REACTIVATE_MODAL]: () => false,
});

const showUpdateConfirmModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const variants = createReducer(
  {},
  {
    [LIBRARY_PROMO_SET_INTERSECT_VARIANTS]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.variants,
  }
);

const showAssignItemsModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_ITEMS_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_ITEMS_MODAL]: () => false,
});

const productCategories = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_CATEGORIES]: (draft, { payload }) => payload.categories,
});

const itemDetails = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_ITEM_DETAILS]: (draft, { payload }) => payload.itemDetails,
});

const nonDeletedPromos = createReducer([], {
  [LIBRARY_PROMO_SET_NON_DELETED_PROMOS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.nonDeletedPromos,
});

const assignedPromos = createReducer([], {
  [LIBRARY_PROMO_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.assignedPromos,
});

const errorsPriceCutsPromo = createReducer([], {
  [LIBRARY_PROMO_SET_ERRORS_PRICE_CUTS_PROMO]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.errors,
});

const showErrorModalPriceCutsPromo = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO]: () => true,
  [LIBRARY_PROMO_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO]: () => false,
});

const currentPageAssignItemsModal = createReducer(0, {
  [LIBRARY_PROMO_ASSIGN_ITEMS_SET_CURRENT_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.currentPage,
});

const totalPageAssignItemsModal = createReducer(0, {
  [LIBRARY_PROMO_ASSIGN_ITEMS_SET_TOTAL_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.totalPage,
});

const selectedItems = createReducer(
  {},
  {
    [LIBRARY_PROMO_SET_SELECTED_GOSTORE_ITEMS]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.selectedItems,
  }
);
const salesTypes = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_PROMO_SET_SALES_TYPES]: (draft, { payload }) => payload.salesTypes,
});

const selectedSalesTypes = createReducer([], {
  [LIBRARY_PROMO_SET_SELECTED_SALES_TYPES]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.selectedSalesTypes,
});

const salesTypeNameSpace = createReducer(null, {
  [LIBRARY_PROMO_SET_SALES_TYPE_NAMESPACE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.salesTypeNameSpace,
});

const showAssignSalesTypeModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_MODAL]: () => false,
});

const showAssignOutletWarnModal = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN_MODAL]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN_MODAL]: () => false,
});

const alreadyAssignedOutlet = createReducer(false, {
  [LIBRARY_PROMO_SET_ALREADY_ASSIGNED_OUTLET]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.alreadyAssignedOutlet,
});

const showAssignOutletWarn = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN]: () => false,
});

const showAssignSalesTypeWarn = createReducer(false, {
  [LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_WARN]: () => true,
  [LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_WARN]: () => false,
});

const previousSalesTypeNames = createReducer([], {
  [LIBRARY_PROMO_SET_PREVIOUS_SALES_TYPE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.previousSalesTypeNames,
});

export default combineReducers({
  actionUpdateName,
  activeAccordion,
  categories,
  currentPage,
  deactivatedPromo,
  deletedPromo,
  detailPromo,
  isSubmitPromoForm,
  isSubmittingForm,
  items,
  nextUpdateAction,
  openRightColumn,
  outlets,
  previousAssignedOutlets,
  promos,
  promoTypes,
  reactivatedPromo,
  selectedOutlets,
  showAssignOutletModal,
  showConfirmReactivateModal,
  showDeactivateModal,
  showDeleteModal,
  showReactivateModal,
  showUpdateConfirmModal,
  totalPage,
  variants,
  showAssignItemsModal,
  productCategories,
  itemDetails,
  nonDeletedPromos,
  assignedPromos,
  errorsPriceCutsPromo,
  showErrorModalPriceCutsPromo,
  currentPageAssignItemsModal,
  totalPageAssignItemsModal,
  selectedItems,
  salesTypes,
  selectedSalesTypes,
  salesTypeNameSpace,
  showAssignSalesTypeModal,
  alreadyAssignedOutlet,
  showAssignOutletWarnModal,
  showAssignOutletWarn,
  showAssignSalesTypeWarn,
  previousSalesTypeNames,
});
